import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=4899b093"
import script from "./CCard.vue?vue&type=script&lang=js"
export * from "./CCard.vue?vue&type=script&lang=js"
import style0 from "./CCard.vue?vue&type=style&index=0&id=4899b093&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4899b093')) {
      api.createRecord('4899b093', component.options)
    } else {
      api.reload('4899b093', component.options)
    }
    module.hot.accept("./CCard.vue?vue&type=template&id=4899b093", function () {
      api.rerender('4899b093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CCard.vue"
export default component.exports